import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_ai-ecosystem-45/artifacts/a9zjgx3r_1-PIC.jpeg";

/**
 * Official AI for everyone logomark — uses the uploaded brand asset.
 * `invert` renders on dark surfaces (the logo art has a white background).
 */
export default function Logo({ size = 40, withWordmark = true, className = "", invert = false }) {
  return (
    <div className={`inline-flex items-center gap-3 ${className}`} aria-label="AI For Everyone">
      <span
        className="relative inline-flex items-center justify-center overflow-hidden"
        style={{
          width: size,
          height: size,
          borderRadius: 6,
          background: invert ? "#FAFAF7" : "transparent",
        }}
      >
        <img
          src={LOGO_URL}
          alt="AI For Everyone"
          width={size}
          height={size}
          loading="eager"
          decoding="async"
          style={{
            width: size,
            height: size,
            objectFit: "contain",
            display: "block",
          }}
        />
      </span>
      {withWordmark && (
        <span
          className="font-display tracking-tight leading-none"
          style={{
            fontWeight: 600,
            fontSize: Math.max(15, Math.round(size * 0.46)),
            color: invert ? "var(--canvas)" : "var(--ink)",
          }}
        >
          AI for everyone
        </span>
      )}
    </div>
  );
}
